const grow = {
  state: {
    growimport: []
  },
  getters: {
    growimport: state => {
      return state.growimport
    }
  },
  mutations: {
    SET_GROWIMPORT(state, growimport) {
      state.growimport = growimport
    }
  },
  actions: {}
}

export default grow



// WEBPACK FOOTER //
// ./src/store/modules/grow.js